import React from 'react';
import error1 from '../Assets/error1.png';


function NoPage() 
{
  return (
    <div style={{ width: "100%", height: "100vh", display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <img src={error1} style={{ width: "80px" }} />
        <h1>Sorry! This page does not exist!</h1>
        <span>This page might be taken down or you have miss-entered the url!</span>
    </div>
  );
}

export default NoPage;